import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  useTheme,
  alpha
} from '@mui/material';
import { Close } from '@mui/icons-material';
import ClientFileUpload from './ClientFileUpload';

interface ClientFileUploadModalProps {
  open: boolean;
  onClose: () => void;
  clientId: string;
  clientName?: string;
  workflowId?: string;
  workflowName?: string;
}

const ClientFileUploadModal: React.FC<ClientFileUploadModalProps> = ({
  open,
  onClose,
  clientId,
  clientName,
  workflowId,
  workflowName
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          bgcolor: alpha(theme.palette.background.paper, 0.98),
          backdropFilter: 'blur(8px)',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          pb: 0,
        }}
      >
        <Box>
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            Upload Files - {clientName || 'Client'} ({clientId})
            {workflowId && (
              <Typography component="span" sx={{ fontWeight: 400, color: 'text.secondary' }}>
                {' / '}{workflowName || 'Workflow'} ({workflowId})
              </Typography>
            )}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {workflowId 
              ? `Upload and manage files for this workflow. Click on a category to upload files directly to that category.`
              : `Upload and manage source files for this client. Click on a category to upload files directly to that category.`
            }
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, m: 0 }}>
        <ClientFileUpload 
          clientId={clientId} 
          clientName={clientName || `Client ${clientId}`}
          workflowId={workflowId}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, pt: 0 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientFileUploadModal;